module.exports = __webpack_public_path__ + "img/weather08.65489d3a.png";